module.exports = __webpack_public_path__ + "img/alfa-cell.cb1f7602.png";